import _ from "lodash"
function updateSingleList(item, list){
  if(!list){
    list = []
  }
  let index = _.findIndex(list, e => {
    return e.dataId == item.dataId
  })
  if(index !== -1){
    // update
    list.splice(index, 1)
    list.unshift(item)
  }else{
    // add
    // 限制单个列表不超过10条数据
    if(list.length >= 10){
      list.pop()
      list.unshift(item)
    }else{
      list.unshift(item)
    }
  }
  return list
}
function certainFunction(obj, keys) {
  return keys.reduce((result, key) => {
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}
function joinStrFunction(form){
  let str = ""
  for (let i in form){
    if(i !== 'dataId'){
      str += `${form[i] ? form[i] : '空'},`
    }
  }
  return str.substr(0, str.length-1)
}
function newDataId(form){
  if(!form.dataId){
    form.dataId = new Date().getTime()
  }
  return form
}
export default {
  state: {
    map: null,
  },
  mutations: {
    /*
    class Item{
      propName: string,
      formName: string,
      value: string,
      form: new FormObj()
    }
    class FormObj{
      [key]: string
    }
    class map{
      [formName]: {
        [propName]: itemArr = Item[],
      },
    }
    */
    updateMap(state, map){
      state.map = map
    },
  },
  actions: {
    loadData({state, commit}){
      if(!state.map){
        // 如果store为空，则初始化store
        let map = window.localStorage.getItem("auto-input-map")
        try{
          map = JSON.parse(map)
        }catch(e){
          console.log(map, e, 'e')
          map = {}
        }
        let autoInputMap =  map || {}
        commit("updateMap", autoInputMap)
      }
    },
    submitForm({state, commit}, {formName, form, propNames}){
      let item = state.map[formName] || {}
      let formValue = certainFunction(form, [...propNames, "dataId"])
      let formStr = joinStrFunction(formValue)
      formValue = newDataId(formValue)
      for(let prop of propNames){
        if(form[prop]){
          item[prop] = updateSingleList({
            propName: prop,
            formName: formName,
            propValue: form[prop],
            form: formValue,
            dataId: formValue.dataId,
            value: formStr
          },item[prop])
        }
      }
      state.map[formName] = item
      window.localStorage.setItem("auto-input-map", JSON.stringify(state.map))
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/auto-input.js